import { Float, Clone, useGLTF, useMatcapTexture, Edges, MatcapTexture, Instance, Instances } from "@react-three/drei";
import { useEffect, useRef, extend } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from 'three'


const material = new THREE.MeshStandardMaterial({
    color: '#ffffef'
})


let island = null


export default function bloodcellIsland() {

    // Refs
    const groupRef = useRef()

    // Models
    const { nodes } = useGLTF(import.meta.env.BASE_URL + 'static/models/blood-cell.glb')



    useEffect(() => {

    }, [])


    // Animation
    useFrame((state, delta) => {

        if(groupRef.current?.children) {
            for (const cell of groupRef.current.children) {
                cell.rotation.z += delta * 0.1
            }
        }

    })

    if (!island) {
        island =
            <Instances
                limit={25} // Optional: max amount of items (for calculating buffer size)

                material={material}
                geometry={nodes.blood_cell.geometry}
                ref={groupRef}
            >

                {[...Array(25)].map((value, index) =>
                    <Instance
                        key={index}
                        position={[
                            (Math.random() - 0.3) * 3,
                            (Math.random() - 0.5) * 2,
                            (Math.random() - 0.5) * 4
                        ]}
                        scale={0.35 + Math.random() * 0.20}
                        rotation={[
                            Math.random() * Math.PI,
                            Math.random() * Math.PI,
                            0
                        ]}
                    >
                        <Edges
                            geometry={nodes.blood_cell.geometry}
                            lineWidth={0.5}
                            threshold={1}
                            color="black"
                            scale={1}
                            opacity={.8}
                            depthTest={true}
                            renderOrder={1000}
                            polygonOffset={true}
                            polygonOffsetFactor={-15}
                        />
                    </Instance>

                )}


            </Instances>


    }


    return <>
        <Float speed={0.2} rotationIntensity={0.8}>
            <group  position={[0.88, -5.3, 1.9]}>
                {
                    island
                }
            </group>
        </Float>
    </>
}

useGLTF.preload(import.meta.env.BASE_URL + 'static/models/blood-cell.gltf')
